import L from "leaflet";
import config from "../../../config";
import superagent from "superagent";

export const S3TileAccessLayer = L.TileLayer.extend({
  getTileUrl: function(tilePoint: L.Coords) {
    const path = L.TileLayer.prototype.getTileUrl.call(this, tilePoint);
    return `${config.endpoints.backofficeStorage}/tiles/${path}`;
  },

  createTile(coords: L.Coords, done: L.DoneCallback) {
    const img = document.createElement("img");
    this.injectUrlWithToken(img, coords, done);
    return img;
  },

  injectUrlWithToken(
    img: HTMLImageElement,
    coords: L.Coords,
    done: L.DoneCallback,
  ) {
    const url = this.getTileUrl(coords);
    const req = superagent
      .get(url)
      .responseType("blob")
      .set("Content-Type", "image/png")
      .set("Authorization", `Bearer ${this.options.accessToken}`);

    // @ts-ignore
    img.request = req;
    // @ts-ignore
    img.startLoadingTime = Date.now();
    req.end((err, res) => {
      if (err) {
        return this._tileOnError(done, img, err);
      }

      img.src = URL.createObjectURL(res.body);
      this._tileOnLoad(done, img);
    });
  },
});
